import { GeneralArea, GeneralUser, useRepositoryQuery } from '@mews-commander/data-access';
import { OptimusProvider } from '@mews-commander/ui';
import { Container, Spinner } from '@optimus-web/core';
import { getDeviceFingerprintPayload } from '../../../../ducks/actions';
import { UnlockFormCredentials } from './UnlockFormCredentials';
import { UnlockFormSso } from './UnlockFormSso';

export const UnlockForm = ({
    user,
    hasUnlockPin,
    isSaving,
    setIsSaving,
}: {
    user: GeneralUser;
    hasUnlockPin: boolean;
    isSaving: boolean;
    setIsSaving: (isSaving: boolean) => void;
}) => {
    const { data: ssoData, isPending } = useRepositoryQuery(
        'generalUsers',
        'getSsoInfo',
        {
            userIdentifier: user.email as string,
            device: getDeviceFingerprintPayload(),
            application: GeneralArea.Commander,
        },
        {
            enabled: !!user.email,
        }
    );
    const hasSsoEnforced = ssoData?.info?.enforceSingleSignOn;

    if (isPending) {
        return <Spinner />;
    }

    return (
        <OptimusProvider density="spacious">
            <Container padding={['100', '0', '200', '0']}>
                {hasSsoEnforced && <UnlockFormSso ssoData={ssoData.info} />}
                {!hasSsoEnforced && (
                    <UnlockFormCredentials
                        ssoData={ssoData?.info}
                        userId={user.id}
                        hasUnlockPin={hasUnlockPin}
                        isSaving={isSaving}
                        setIsSaving={setIsSaving}
                    />
                )}
            </Container>
        </OptimusProvider>
    );
};
